import React, { useState, useRef, useMemo, useCallback } from 'react';
import CheckboxRow, { CheckboxRowProps } from './CheckboxRow';

export interface ListVirtualizationProps {
    items: Array<CheckboxRowProps>;
    itemHeight: number;
    containerHeight: number;
}

function ListVirtualization({ items, itemHeight, containerHeight }: ListVirtualizationProps) {
    const ref = useRef<HTMLDivElement>(null);

    const [scrollTop, setScrollTop] = useState(0);

    const startIndex = Math.floor(scrollTop / itemHeight);
    const endIndex = Math.min(startIndex + Math.ceil(containerHeight / itemHeight), items.length);

    const visibleItems = useMemo(() => items.slice(startIndex, endIndex), [items, startIndex, endIndex]);
    const invisibleItemsHeight = (startIndex + visibleItems.length - endIndex) * itemHeight;

    const handleScroll = useCallback(() => {
        if (ref.current) {
            setScrollTop(ref.current.scrollTop);
        }
    }, []);

    return (
        <div
            className="overflow-y-auto px-2.5"
            ref={ref}
            style={{ maxHeight: `${containerHeight}px` }}
            onScroll={handleScroll}
        >
            <div style={{ height: `${items.length * itemHeight}px` }}>
                <div
                    className="relative"
                    style={{
                        height: `${visibleItems.length * itemHeight}px`,
                        top: `${startIndex * itemHeight}px`,
                    }}
                >
                    {visibleItems.map((item) => (
                        <CheckboxRow key={item.id} {...item} style={{ height: `${itemHeight}px` }} />
                    ))}
                </div>
                <div style={{ minHeight: `${invisibleItemsHeight}px` }} />
            </div>
        </div>
    );
}

export default ListVirtualization;
